/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsExercisesListParams,
  AdminWorkoutsExercise,
  PaginatedAdminExerciseListList,
  PatchedAdminWorkoutsExercise
} from '.././model';

import adminV1OrganizationsExercisesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsExercisesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsExercisesRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsExercisesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsExercisesPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsExercisesDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesList = (
    organizationId: number,
    params?: AdminV1OrganizationsExercisesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesListMutator<PaginatedAdminExerciseListList>>,) => {
      return adminV1OrganizationsExercisesListMutator<PaginatedAdminExerciseListList>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesCreate = (
    organizationId: number,
    adminWorkoutsExercise: NonReadonly<AdminWorkoutsExercise>,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesCreateMutator<AdminWorkoutsExercise>>,) => {
      return adminV1OrganizationsExercisesCreateMutator<AdminWorkoutsExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminWorkoutsExercise
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesRetrieveMutator<AdminWorkoutsExercise>>,) => {
      return adminV1OrganizationsExercisesRetrieveMutator<AdminWorkoutsExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesUpdate = (
    organizationId: number,
    id: number,
    adminWorkoutsExercise: NonReadonly<AdminWorkoutsExercise>,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesUpdateMutator<AdminWorkoutsExercise>>,) => {
      return adminV1OrganizationsExercisesUpdateMutator<AdminWorkoutsExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminWorkoutsExercise
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminWorkoutsExercise: NonReadonly<PatchedAdminWorkoutsExercise>,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesPartialUpdateMutator<AdminWorkoutsExercise>>,) => {
      return adminV1OrganizationsExercisesPartialUpdateMutator<AdminWorkoutsExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminWorkoutsExercise
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsExercisesDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsExercisesDestroyMutator<void>>,) => {
      return adminV1OrganizationsExercisesDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/exercises/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsExercisesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesList>>>
export type AdminV1OrganizationsExercisesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesCreate>>>
export type AdminV1OrganizationsExercisesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesRetrieve>>>
export type AdminV1OrganizationsExercisesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesUpdate>>>
export type AdminV1OrganizationsExercisesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesPartialUpdate>>>
export type AdminV1OrganizationsExercisesDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsExercisesDestroy>>>
